import React, { useEffect, useState } from 'react';
import { FaStar } from 'react-icons/fa';
import { resolveMediaUrl } from '../services/api';

const PopupAnnouncementModal = ({ announcement }) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!announcement?.id) {
            setOpen(false);
            return;
        }
        setOpen(true);
    }, [announcement]);

    if (!announcement || !open) return null;

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 p-4" onClick={handleClose}>
            <div className="w-full max-w-4xl overflow-hidden rounded-2xl bg-white shadow-2xl" onClick={(e) => e.stopPropagation()}>
                <div className="grid md:grid-cols-2">
                    <div className="h-64 bg-slate-100 md:h-full">
                        {announcement.image ? (
                            <img
                                src={resolveMediaUrl(announcement.image)}
                                alt={announcement.title}
                                className="h-full w-full object-cover"
                            />
                        ) : (
                            <div className="flex h-full items-center justify-center text-slate-400">No Image</div>
                        )}
                    </div>
                    <div className="p-6 md:p-8">
                        <div className="mb-3 inline-block rounded-full bg-emerald-100 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-emerald-700">
                            {announcement.type?.replace('_', ' ') || 'announcement'}
                        </div>
                        <div className="mb-3 flex items-center gap-1 text-amber-500">
                            {Array.from({ length: 5 }).map((_, index) => (
                                <FaStar key={index} className={index < Number(announcement.rating || 0) ? 'opacity-100' : 'opacity-20'} />
                            ))}
                        </div>
                        <h2 className="mb-3 text-2xl font-bold text-gray-800">{announcement.title}</h2>
                        <p className="mb-4 whitespace-pre-line text-gray-700">{announcement.message}</p>

                        {announcement.type === 'donation_campaign' && (
                            <div className="rounded-xl bg-emerald-50 p-4">
                                <p className="text-sm font-semibold text-emerald-800">Donation Details</p>
                                <p className="mt-1 text-sm text-emerald-700">
                                    Raised: PKR {Number(announcement.donation_raised || 0).toLocaleString()}
                                </p>
                                <p className="text-sm text-emerald-700">
                                    Goal: PKR {Number(announcement.donation_goal || 0).toLocaleString()}
                                </p>
                                <div className="mt-2 h-2 rounded-full bg-white">
                                    <div
                                        className="h-2 rounded-full bg-emerald-600"
                                        style={{
                                            width: `${Math.min(
                                                100,
                                                Math.round(
                                                    (Number(announcement.donation_raised || 0) / Math.max(1, Number(announcement.donation_goal || 1))) * 100
                                                )
                                            )}%`,
                                        }}
                                    ></div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PopupAnnouncementModal;
